import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PostalAddress } from '../../../../../generated/generated-types';

@Component({
  selector: 'app-widget-postal-addresses',
  templateUrl: './widget-postal-addresses.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
  ]
})
export class WidgetPostalAddressesComponent extends FieldType implements OnInit {

  get postalAddresses() {
    return this.model as PostalAddress[];
  }

  ngOnInit() {
  }

}
